import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]

  connect() {
    this.visible = false
    // Store the original icon HTML (eye icon)
    this.eyeIconHTML = this.iconTarget.innerHTML
    // Store the eye-off icon HTML - we'll swap to this when visible
    this.eyeOffIconHTML = this.getEyeOffIconHTML()
  }

  toggle() {
    this.visible = !this.visible

    if (this.visible) {
      this.inputTarget.type = "text"
      this.iconTarget.innerHTML = this.eyeOffIconHTML
    } else {
      this.inputTarget.type = "password"
      this.iconTarget.innerHTML = this.eyeIconHTML
    }
  }

  getEyeOffIconHTML() {
    // Return the eye-off icon SVG (from lucide icons)
    return `<svg xmlns="http://www.w3.org/2000/svg" class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"/><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"/><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"/><path d="m2 2 20 20"/></svg>`
  }
}